<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="mb10 mt10 BGwhite pad12 relative">
    <div class="absolute t r mt36 Con mr20 b500" @click="copy">复制</div>
    <div class="width75">
      <p class="b500 mb8 size16">{{storeinfo.name}}&nbsp;&nbsp;&nbsp;{{ storeinfo.mobile }}</p>
      <p class="C666 size14">{{ storeinfo.address }}</p>
    </div>
  </div>
  <div class="size14 pad12 BGwhite">
    <input type="text" v-model="no" placeholder="填写退货运单号" class="width100 height30px size15" />
  </div>

  <van-field v-model="fieldText" is-link readonly placeholder="选择物流" @click="showPicker = true" />
  <van-popup v-model:show="showPicker" round position="bottom">
    <van-picker :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
  </van-popup>

  <div class="pad30"></div>
  <div class="fixed l r b" v-show="$store.state.nokey">
    <p class="center Cred size12 mb10">请与卖家协商一致后退回!</p>
    <div class="pad12 gray">
      <van-button round block type="primary" @click="handleConfirm">确认提交</van-button>
    </div>
  </div>
  <!-- <input type="hidden" id="myInput" :value="storeinfo.mobile"> -->
</template>

<script>
import useClipboard from 'vue-clipboard3'
import ajax from "@/utils/request.js";
import { showToast } from "vant";
export default {
  data () {
    return {
      checked: '1',
      address: {},
      no: "",
      fieldValue: "",
      fieldText: "",
      showPicker: false,
      columns: [],
      storeinfo: {}
    }
  },
  watch: {
  },
  methods: {
    async copy () {
      const { toClipboard } = useClipboard()
      try {
        await toClipboard(this.storeinfo.mobile)
        showToast("复制订单号成功")
      } catch (e) {
        showToast("当前浏览器版本不支持复制，请长按复制")
      }
      // var copyText = document.getElementById("myInput");
      // copyText.select();
      // navigator.clipboard.writeText(copyText.value);
      // this.showToast("复制成功")
    },
    openImg (src) {
      if (!src) { return this.showToast('没有图片资源') }
      location.href = src;
    },
    getDetail () {
    },
    apply () {
    },
    next () {
      history.back()
    },
    onConfirm ({ selectedOptions }) {
      this.showPicker = false;
      this.fieldValue = selectedOptions[0].value;
      this.fieldText = selectedOptions[0].text;
    },
    //提交物流信息
    handleConfirm () {
      const data = {
        id: this.$route.query.id,
        shipping_code: this.fieldValue,
        invoice_no: this.no
      }
      ajax.post("order/logistics", data).then(res => {
        if (res.errcode === 1) {
          showToast(res.message)
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        }
      })
    }
  },
  created () {
    ajax.post("order/getshippinglist", { id: this.$route.query.id }).then(res => {
      this.storeinfo = res.data.deliver
      let arr = res.data.shipping_list.map(item => {
        return { text: item.shipping_name, value: item.shipping_code }
      })
      this.columns = arr
    })
  }
}
</script>

<style>
</style>
